module.exports = __webpack_public_path__ + "static/logo-54e8df8e553dc2705582771d0555fc7d.png";